import { throttle } from 'lodash';

let scrollpos = window.scrollY;
const header = document.querySelector(".header");
const button = document.querySelector(".fab-donate__button");
if(button && header) {
    const header_height = header.offsetHeight;
    const button_height = button.offsetHeight;
    const add_class_on_scroll = () => document.querySelector('body').classList.add("fab-scrolled")
    const remove_class_on_scroll = () => document.querySelector('body').classList.remove("fab-scrolled");

    const add_class_on_scroll_bottom = () => document.querySelector('body').classList.add("fab-scrolled-bottom")
    const remove_class_on_scroll_bottom = () => document.querySelector('body').classList.remove("fab-scrolled-bottom");

    let body = document.body,
        html = document.documentElement;

    let height = Math.max( body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight );

    function onScroll(e) {
        scrollpos = window.scrollY;
        if (scrollpos >= header_height) { add_class_on_scroll() }
        else { remove_class_on_scroll() }

        if(scrollpos + window.innerHeight >= height - button_height) {
            add_class_on_scroll_bottom()
        }
        else {
            remove_class_on_scroll_bottom();
        }
    }

    window.addEventListener('scroll', throttle(onScroll, 500));
    window.addEventListener('resize', throttle(onScroll, 500));
}
